import request from '../../../shared/request'

export function getScheduleManufacturingDates(job_id) {
  return request(`/job/schedules/${job_id}/manufacturing`)
}

export function addScheduleManufacturingDates(payload) {
  return request(`/job/schedules/${payload.job_id}/manufacturing`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteScheduleManufacturing(payload) {
  return request(`/job/schedules/${payload.schedule_id}/manufacturing`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleManufacturingDates(payload) {
  return request(`/job/schedules/${payload.job_id}/manufacturing`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleManufacturingNotes(payload) {
  return request(`/job/schedules/${payload.job_id}/manufacturing/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/scheduleManufacturing.js